module.exports = __webpack_public_path__ + "img/已完成.05dd10e1.jpg";